import { RSAA } from 'redux-api-middleware'
import fetch from 'cross-fetch'

import { matchesInArr, findProgram } from '../utils/methods'
import * as ActionTypes from './types'

export const retrieveRecommendedPrograms = missingSkills => (
  dispatch,
  getState
) =>
  dispatch({
    [RSAA]: {
      types: [
        ActionTypes.PROGRAMS_REQUEST,
        {
          type: ActionTypes.PROGRAMS_SUCCESS,
          payload: (action, state, res) =>
            res
              .json()
              .then(res => {
                const { education, experience } = getState().user
                let filteredArr = []

                res.stories.map(prog => {
                  if (
                    (prog.content.experience_options.includes(experience) &&
                      prog.content.education_level.includes(education)) ||
                    ((experience === '6-9' || experience === '10+') &&
                      prog.content.program_code !== 'mba' &&
                      education === 'High School')
                  ) {
                    filteredArr.push(
                      Object.assign(prog.content, {
                        missingSkillMatches: matchesInArr(
                          prog.content.skills_list,
                          missingSkills
                        )
                      })
                    )
                  }
                  return filteredArr
                })
                return {
                  filteredArr: filteredArr,
                  programs: res.stories
                }
              })
              .then(progObj => {
                const { education, experience } = getState().user

                const sortedArr = progObj.filteredArr.sort((p, p2) => {
                  return p2.missingSkillMatches - p.missingSkillMatches
                })

                const defaultPrograms =
                  experience !== 'Less than 1' && experience !== 'Student'
                    ? [
                        Object.assign(
                          findProgram(progObj.programs, 'mim').content,
                          {
                            missingSkillMatches: matchesInArr(
                              findProgram(progObj.programs, 'mim').content
                                .skills_list,
                              missingSkills
                            )
                          }
                        ),
                        Object.assign(
                          findProgram(progObj.programs, 'mba').content,
                          {
                            missingSkillMatches: matchesInArr(
                              findProgram(progObj.programs, 'mba').content
                                .skills_list,
                              missingSkills
                            )
                          }
                        )
                      ]
                    : [
                        Object.assign(
                          findProgram(progObj.programs, 'mim').content,
                          {
                            missingSkillMatches: matchesInArr(
                              findProgram(progObj.programs, 'mim').content
                                .skills_list,
                              missingSkills
                            )
                          }
                        )
                      ]

                const embaRecom = Object.assign(
                  findProgram(progObj.programs, 'emba').content,
                  {
                    missingSkillMatches: matchesInArr(
                      findProgram(progObj.programs, 'emba').content.skills_list,
                      missingSkills
                    )
                  }
                )

                const removeMimSortedArr = sortedArr.filter(
                  prog => prog.program_code !== 'mim'
                )

                switch (sortedArr.length === 0) {
                  case true:
                    return {
                      programs: defaultPrograms
                    }
                  default:
                    if (
                      (experience === '6-9' || experience === '10+') &&
                      education === 'High School'
                    ) {
                      return { programs: [embaRecom, removeMimSortedArr[0]] }
                    } else if (sortedArr.length === 1) {
                      return { programs: [sortedArr[0]] }
                    } else {
                      return { programs: [sortedArr[0], sortedArr[1]] }
                    }
                }
              })
        },
        ActionTypes.PROGRAMS_FAILURE
      ],
      endpoint: `https://api.storyblok.com/v1/cdn/stories/?starts_with=gmaccareerexplorer/programs&token=${
        process.env.REACT_APP_SB_TOKEN
      }&cv=${Date.now()}`,
      method: 'GET',
      fetch: async (...args) => fetch(...args)
    }
  })
